import { useNavigate, useRouteError } from "react-router-dom";

function ErrorBoundary() {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const error: any = useRouteError();

  const getError = () => {
    try {
      if (error instanceof Error) {
        return JSON.stringify(error, Object.getOwnPropertyNames(error));
      }
      return error.toString();
    } catch (e) {
      return error?.message || "未知错误";
    }
  };

  const handleGoHome = () => {
    navigate("/home");
  };

  const handleClose = () => {
    window.close();
  };

  return (
    <div className="w-full h-full p-x-20 flex flex-col items-center justify-center bg-mx-white">
      <div className="text-mx-black font-600 text-10">OH NO! 页面崩溃了!</div>
      <div className="m-t-10 text-mx-tertiary">{getError()}</div>
      <div className="m-t-10">
        <button
          className="h-12 p-x-4 outline-none bg-mx-primary border-none rounded-2 text-white text-lg cursor-pointer"
          onClick={handleGoHome}
        >
          返回首页
        </button>
        <button
          className="m-l-4 h-12 p-x-4 outline-none bg-mx-quaternary border-none rounded-2 text-white text-lg cursor-pointer"
          onClick={handleClose}
        >
          退出应用
        </button>
      </div>
    </div>
  );
}

export default ErrorBoundary;
